//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const UnshadowBlocks: FeatureFlag = {"Id":"UnshadowBlocks","Label":"Unshadow calculation blocks in toolkit","Impact":"Adding a calculation operation in the calculation editor adds it as fully real calculations, instead of a top calculation element with virtual shadow children","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
